(ns dre.modals.surveys.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.modals.events :as-alias modals]
   [dre.network :as-alias network]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path
  [:modals :surveys])

;; events
(rf/reg-event-fx
 ::show
 [rf/trim-v]
 (fn-traced
  [{db :db} _]
  (let [survey-name (get-in db [:app :user :survey-names :docsearch])
        viewed? (get-in db [:modals :surveys :viewed?])]
    (when (and (not viewed?) survey-name)
      {:dispatch-later {:ms 1000
                        :dispatch [::modals/set-modal :surveys/survey]}}))))

(rf/reg-event-fx
 ::init
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} _]
  {:db {:data {}
        :viewed? (:viewed? db)}}))

(rf/reg-event-fx
 ::clear
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [_]]
  {:dispatch [::modals/clear]}))

(rf/reg-event-fx
 ::update-data
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [key value]]
  {:db (assoc-in db [:data key] value)}))

(rf/reg-event-fx
 ::submit
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [survey-name]]
  {::network/request [{:endpoint :surveys/survey
                       :context {:survey-name survey-name}}
                      {:body (:data db)
                       :on-success [::submit-success]}]}))

(rf/reg-event-fx
 ::submit-success
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response]}]]
  {:db (assoc db :viewed? true)}))

(rf/reg-event-fx
 ::dismiss
 [rf/trim-v]
 (fn-traced
  [{db :db} _]
  (let [survey-name (get-in db [:app :user :survey-names :docsearch])]
    {:fx [[:dispatch [::clear]]
          [::network/request [{:endpoint :surveys/survey
                               :context {:survey-name survey-name}}
                              {:body {:dismissed true}
                               :on-success [::dismiss-success]}]]]})))

(rf/reg-event-fx
 ::dismiss-success
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response]}]]
  {:db (assoc db :viewed? true)}))

;; subscriptions

(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db db-path)))

(rf/reg-sub
 ::data
 :<- [::state]
 (fn [db _]
   (:data db)))
